import React from 'react';
import {Drawer as MUIDrawer} from '@mui/material';

type SideNavMenu = {
  open: boolean;
  onClose: () => void;
  children: any;
};

const SideNavMenu: React.FC<SideNavMenu> = (props) => {
  return (
    <MUIDrawer
      sx={{width: 100}}
      PaperProps={{
        sx: {
          boxShadow: 'none',
          width: '100%',
          height: '100vh',
          overflow: 'auto',
        },
      }}
      onClose={props.onClose}
      anchor='left'
      open={props.open}
      ModalProps={{
        keepMounted: true,
        onClose: props.onClose,
      }}
      variant='temporary'>
      {props.children}
    </MUIDrawer>
  );
};
export default SideNavMenu;
export type {SideNavMenu};
